import type { MessageObjectTypeDefinition } from '@open-mercato/shared/modules/messages/types'

export const messageObjectTypes: MessageObjectTypeDefinition[] = []

export default messageObjectTypes
